export { default } from "./WarningIcon";
